import { CalendarMonth, Category as CategoryIcon } from '@mui/icons-material';
import { SvgIcon } from '@mui/material';
import {
  country,
  employees,
  industries,
  rank,
  spendMax,
  spendMin,
  tld,
  vertical,
} from '~/scripts/columns';
import type { Filters } from '~/types/filters';

export const allFilters: Record<
  keyof Filters.Filters | 'added',
  { icon: typeof SvgIcon; name: string; prefix: string; tooltip: string }
> = {
  added: {
    icon: CalendarMonth as typeof SvgIcon,
    name: 'Activity Dates',
    prefix: 'Added Since: ',
    tooltip:
      'Filter for websites that have been active on or after a certain date',
  },
  tld: {
    icon: tld.icon as typeof SvgIcon,
    name: tld.name,
    prefix: '',
    tooltip: tld.description,
  },
  spend_min: {
    icon: spendMin.icon as typeof SvgIcon,
    name: 'Min Spend',
    prefix: 'Min. Spend: ',
    tooltip: spendMin.description,
  },
  spend_max: {
    icon: spendMax.icon as typeof SvgIcon,
    name: 'Max Spend',
    prefix: 'Max. Spend: ',
    tooltip: spendMax.description,
  },
  rank_min: {
    icon: rank.icon as typeof SvgIcon,
    name: 'Min Rank',
    prefix: 'Min. Rank: ',
    tooltip: rank.description,
  },
  rank_max: {
    icon: rank.icon as typeof SvgIcon,
    name: 'Max Rank',
    prefix: 'Max. Rank: ',
    tooltip: rank.description,
  },
  country: {
    icon: country.icon as typeof SvgIcon,
    name: country.name,
    prefix: '',
    tooltip: country.description,
  },
  vertical: {
    icon: vertical.icon as typeof SvgIcon,
    name: vertical.name,
    prefix: '',
    tooltip: vertical.description,
  },
  industries: {
    icon: industries.icon as typeof SvgIcon,
    name: industries.name,
    prefix: '',
    tooltip: industries.description,
  },
  employees_min: {
    icon: employees.icon as typeof SvgIcon,
    name: 'Min Employees',
    prefix: 'Min. Employees: ',
    tooltip: employees.description,
  },
  employees_max: {
    icon: employees.icon as typeof SvgIcon,
    name: 'Max Employees',
    prefix: 'Max. Employees: ',
    tooltip: employees.description,
  },
  tags: {
    icon: CategoryIcon as typeof SvgIcon,
    name: 'Popular Lists',
    prefix: 'List: ',
    tooltip: 'Filter for websites that are part of a popular list',
  },
};
